export const SET_DOMAINS = "setDomains";
export const CLEAR_DOMAINS = "clearDomains";
export const REMOVE_DOMAIN = "removeDomain";
export const SET_DOMAIN = "setDomain";
export const CLEAR_DOMAIN = "clearDomain";
export const SET_FIELD_DOMAIN = "setFieldDomain";
export const SET_FIELD_SUBDOMAIN = "setFieldSubdomain";
export const SET_FIELD_EMAILS = "setFieldEmails";
export const SET_EMAILS = "setEmails";
export const CLEAR_EMAILS = "clearEmails";
